var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.33 107.93C24.7133 107.93 0.72998 83.9467 0.72998 54.33C0.72998 24.7133 24.7133 0.72998 54.33 0.72998C83.9467 0.72998 107.93 24.7133 107.93 54.33C107.93 83.9467 83.9467 107.93 54.33 107.93ZM78.5867 36.7733C76.9797 35.1664 74.4305 35.1664 72.8236 36.7733L47.2269 63.04L35.8369 51.2469C34.23 49.64 31.6808 49.64 30.0738 51.2469C28.4669 52.8538 28.4669 55.5338 30.0738 57.1408L44.4105 71.8808C46.0174 73.4877 48.5666 73.4877 50.1736 71.8808L78.7169 42.6674C80.1931 41.0657 80.1937 38.3855 78.5867 36.7733Z",
    fill: "#4EBF6E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.5a313990ee647001a4a3c21299f43ad0.svg";
export { ForwardRef as ReactComponent };